module.exports = __webpack_public_path__ + "media/album_browser.a25300b4.webm";